module.exports = "<div class=\"card\" *ngIf=\"cardWrapper\">\n    <div class=\"card-block\">\n        <b>{{label}}</b>\n        <hr class=\"m-t-0 m-b-0\">\n        <amCharts [id]=\"id\" [options]=\"options\" [style.width.%]=\"width\" [style.height.px]=\"height\"></amCharts>\n    </div>\n</div>\n<div *ngIf=\"!cardWrapper\">\n    <b>{{label}}</b>\n    <hr class=\"m-t-0 m-b-0\">\n    <amCharts [id]=\"id\" [options]=\"options\" [style.width.%]=\"width\" [style.height.px]=\"height\"></amCharts>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/widgets/chart/chart.component.html
// module id = ./src/app/shared/components/widgets/chart/chart.component.html
// module chunks = main